<div class="container-card-row-check" [ngClass]="{activate: value}">
    <div class="container-card-row-check-background row" (click)="onCheck()">
        <div class="container-card-row-check-front"></div>
    </div>
</div>
